import React from 'react';
import cx from 'classnames';
import styles from './ActionCard.module.scss';
import type { ActionCardProps } from './ActionCard.types';
import { NavLink } from '../../molecules';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

/**
 * ActionCard component definition.
 */
const ActionCard = (props: ActionCardProps) => {
  const {
    disabled,
    className,
    children,
    onClick,
    to,
    ...restProps
  } = props;

  const RootElement: React.ElementType = to !== undefined ? NavLink : 'div'

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // Check if the event's target has its own click event
    if (e.target instanceof HTMLElement && e.target.hasAttribute('onClick')) {
      e.stopPropagation();
    }
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  const variantProps = useBuildVariantProps(
    'action-card',
  );

  return (
    <RootElement
      role='button'
      aria-label='Action Card'
      aria-disabled={disabled}
      tabIndex={0}
      {...{...restProps, to}}
      className={cx(
        styles.actionCard,
        {
          [styles.disabled]: disabled,
        },
        className,
      )}
      onClick={handleClick}
      {...variantProps}
    >
      {children}
    </RootElement>
  );
};

export default ActionCard;
